module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Pricing Rules – Maximize Your Revenue with Smart Pricing")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column p-4 ml-1 fs-normal modal-content-fixed",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.currentPage === 1) ? _c('div', [_c('h3', [_vm._v("1. What is Pricing Rules?")]), _vm._v(" "), _c('ul', {
    staticClass: "ps-4 p-3"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("With Pricing Rules, you can optimize your pricing strategy automatically. This feature\n                        allows you to:")])]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-2 ml-4"
  }, [_vm._v("• Adjust prices based on real-time demand")]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-2 ml-4"
  }, [_vm._v("• Set different pricing by sales channel and day\n                    of\n                    the\n                    week\n                ")]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-4 ml-4"
  }, [_vm._v("• Automatically close sales channels as\n                    occupancy\n                    increases")]), _vm._v(" "), _c('li', [_c('span', [_vm._v("No more static prices or manual adjustments — let your pricing work for you.")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 2) ? _c('div', [_c('h3', [_vm._v("2. Why Use It?")]), _vm._v(" "), _c('ul', {
    staticClass: "ps-4 p-3"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("When your activities are in high demand, you might be undercharging — or filling seats\n                        through low-margin channels. Pricing Rules solves that by:")])]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-2 ml-4"
  }, [_vm._v("• Increasing prices when demand is high")]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-2 ml-4"
  }, [_vm._v("• Prioritizing more profitable channels")]), _vm._v(" "), _c('li', {
    staticClass: "custom-bullet mb-2 ml-4"
  }, [_vm._v("• Avoiding last-minute underselling")]), _vm._v(" "), _c('li', [_c('span', [_c('b', [_vm._v("“If you don’t sell those last seats today, you can’t sell them\n                            tomorrow.”")])])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_vm._v("With Pricing Rules, you stay in control and make the most of every seat.")])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 3) ? _c('div', [_c('h3', [_vm._v("3. Real-Life Impact")]), _vm._v(" "), _c('ul', {
    staticClass: "ps-4 p-3"
  }, [_c('li', [_c('span', [_c('i', {
    staticClass: "fas fa-chart-bar"
  }), _vm._v("Example: You sell 20 seats per day at\n                        €100.")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("→ Revenue = €2,000/day")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_c('span', [_vm._v("Now apply Pricing Rules:")])]), _vm._v(" "), _c('li', {
    staticClass: "ml-4"
  }, [_c('span', [_vm._v("- After 60% occupancy: price increases 5% (€105)")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-1 ml-4"
  }, [_c('span', [_vm._v("- After 80% occupancy: price increases 10% (€110)")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-bullseye fa-spin",
    staticStyle: {
      "color": "#e66565"
    }
  }), _vm._v("New revenue:\n                        €2,060/day")])]), _vm._v(" "), _c('li', [_c('span', [_c('i', {
    staticClass: "fas fa-chart-line fa-sm",
    staticStyle: {
      "color": "#62b3fe"
    }
  }), _vm._v("Annual impact: +€21,900 (1\n                        activity/day x 365)")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-2"
  }, [_c('span', [_vm._v("This is just one of many pricing scenarios you can automate.")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 4) ? _c('div', [_c('h3', [_vm._v("4. How You Can Use It?")]), _vm._v(" "), _c('ul', {
    staticClass: "ps-4 p-3"
  }, [_c('li', {
    staticClass: "mb-4"
  }, [_c('b', [_c('i', {
    staticClass: "fas fa-check-square",
    staticStyle: {
      "color": "#32e275"
    }
  }), _vm._v(" Dynamic Pricing by Demand")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raise prices when you hit a certain % of capacity")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-4"
  }, [_c('b', [_c('i', {
    staticClass: "fas fa-check-square",
    staticStyle: {
      "color": "#32e275"
    }
  }), _vm._v(" Channel Management")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Close sales channels once your occupancy reaches a threshold — and keep the last seats for\n                        the best margins")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-4"
  }, [_c('b', [_c('i', {
    staticClass: "fas fa-check-square",
    staticStyle: {
      "color": "#32e275"
    }
  }), _vm._v(" Weekday/Weekend Pricing")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Automatically apply different prices by day of the week")])])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 5) ? _c('div', [_c('h3', [_vm._v("5. Rule Variables You Can Configure")]), _vm._v(" "), _c('div', {
    staticClass: "ps-4"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-variable"
  }, [_vm._v("Variable")]), _vm._v(" "), _c('th', {
    staticClass: "col-action"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "col-notes"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.rows), function(row, j) {
    return _c('tr', {
      key: ("row-" + j)
    }, [_c('td', [_vm._v(_vm._s(row.variable))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.notes))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 6) ? _c('div', [_c('h3', [_vm._v("6. Ready to Get Started?")]), _vm._v(" "), _c('ul', {
    staticClass: "ps-4 p-3"
  }, [_c('li', {
    staticClass: "mb-4"
  }, [_c('span', [_vm._v("Take full control of your pricing — no more guesswork, no more missed\n                        revenue")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-4"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-rocket",
    staticStyle: {
      "color": "#bb2525"
    }
  }), _vm._v("Start boosting your\n                        revenue\n                        automatically")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-4"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-wrench fa-rotate-270",
    staticStyle: {
      "color": "#657186"
    }
  }), _vm._v("Easy to\n                        configure")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-4"
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-chart-line fa-sm",
    staticStyle: {
      "color": "#62b3fe"
    }
  }), _vm._v("Proven\n                        results")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.currentPage > 1) ? _c('button', {
    staticClass: "btn blue wider footer-btn",
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("\n            Back\n            "), _c('i', {
    staticClass: "fas fa-chevron-left next-icon-space mt-0"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentPage < 6) ? _c('button', {
    staticClass: "btn blue wider footer-btn",
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n            Next\n            "), _c('i', {
    staticClass: "fas fa-chevron-right next-icon-space mt-0"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentPage === 6) ? _c('button', {
    staticClass: "btn green wider footer-btn",
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("\n            Activate\n        ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284a4aa2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/PricingRulesLearnMore.vue
// module id = 1444
// module chunks = 0